export const EVENT_VIEW_MODES = {
  afisha: 'afisha',
  media: 'media',
  schedule: 'schedule',
} as const;

export type EventViewMode =
  (typeof EVENT_VIEW_MODES)[keyof typeof EVENT_VIEW_MODES];

export const EVENT_MEDIA_MODES = {
  photos: 'photos',
  videos: 'videos',
} as const;

export type EventMediaMode =
  (typeof EVENT_MEDIA_MODES)[keyof typeof EVENT_MEDIA_MODES];

export const EVENTS_ROUTE_NAMES = {
  afisha: 'events',
  photos: 'events-photos',
  videos: 'events-videos',
  schedule: 'events-schedule',
} as const;

export const EVENTS_GALLERY_DETAIL_ROUTE_NAMES = {
  photos: 'events-photo-gallery-detail',
  videos: 'events-video-gallery-detail',
} as const;
